import React, { useState } from 'react';
import { LinkItem } from '../../models/cms';
import { ArrowDownIcon } from '../../components/icons';
import { Link } from 'react-router-dom';

export interface CustomProps {
  title: string;
  submenu?: LinkItem[];
}

const FooterBlock = (props: CustomProps) => {
  const [toggle, setToggle] = useState('');

  return (
    <>
      <div
        className="flex items-center px-3 py-2 md:p-0 md:text-tertiary text-sm md:text-lg md:mb-5 font-medium md:font-light bg-[#18B363] md:bg-transparent rounded-lg md:rounded-none"
        onClick={() => {
          if (props.title === toggle) {
            setToggle('');
            return;
          }
          setToggle(props?.title);
        }}
      >
        <span className="relative top-0.5 md:top-0">{props.title}</span>
        <span className="md:hidden ltr:ml-auto rtl:mr-auto">
          <ArrowDownIcon
            className={`duration-700 ${toggle === props.title &&
              'ltr:-rotate-180 rtl:rotate-180'}`}
          />
        </span>
      </div>
      <div
        className={`collapse-wrapper duration-1000 md:text-[11px] text-gray-900 md:text-white ${
          toggle === props.title ? 'is-open' : ''
        }`}
      >
        <div className="overflow-hidden md:overflow-visible">
          <ul className="px-3 pb-1.5 md:p-0">
            {props?.submenu?.map(
              (subitem) =>
                !subitem?.inactive && (
                  <li key={subitem?.id}>
                    <a
                      href={`${process.env.REACT_APP_CMS_URL}${subitem?.url || ''}`}
                      target='_blank'
                      className="mb-0.5 block py-0.5 md:py-0 duration-300 hover:text-white"
                    >
                      {subitem?.label}
                    </a>
                  </li>
                )
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default FooterBlock;
